import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { SignupManagementComponent } from './signup/signupmanagment.component';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';

const states:GaStateDeclaration[] = [
  {
    name: 'main.management',
    url: '/management',
    abstract: true
  },
  {
    name: 'main.management.signup',
    url: '/signup',
    component: SignupManagementComponent
  }
];

@NgModule({
  declarations: [
    SignupManagementComponent
  ],
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule
  ]
})
export class ManagementModule {
}